enum Availability {
    AM = "AM",
    PM = "PM",
    BOTH = "BOTH",
    NONE = "NONE"
}

export default Availability;